/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationTotalAuthenticatedUsersStatQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['UUID']['input'];
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ApplicationTotalAuthenticatedUsersStatQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, employees?: { __typename: 'ClientEmployeeTypeConnection', edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', edges: Array<{ __typename: 'ClientEmployeeSessionTypeEdge', node?: { __typename: 'ClientEmployeeSessionType', isAuthenticated?: boolean | null } | null } | null> } | null } | null } | null> } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ApplicationTotalAuthenticatedUsersStatDocument = new TypedDocumentString(`
    query ApplicationTotalAuthenticatedUsersStat($applicationId: UUID!, $clientId: UUID!) {
  clientApplication(id: $applicationId, clientId: $clientId) {
    id
    employees {
      edges {
        node {
          id
          sessions {
            edges {
              node {
                isAuthenticated
              }
            }
          }
        }
      }
    }
  }
}
    `);

export const useApplicationTotalAuthenticatedUsersStatQuery = <
      TData = ApplicationTotalAuthenticatedUsersStatQuery,
      TError = unknown
    >(
      variables: ApplicationTotalAuthenticatedUsersStatQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationTotalAuthenticatedUsersStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationTotalAuthenticatedUsersStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationTotalAuthenticatedUsersStatQuery, TError, TData>(
      {
    queryKey: ['ApplicationTotalAuthenticatedUsersStat', variables],
    queryFn: fetcher<ApplicationTotalAuthenticatedUsersStatQuery, ApplicationTotalAuthenticatedUsersStatQueryVariables>(ApplicationTotalAuthenticatedUsersStatDocument, variables),
    ...options
  }
    )};

useApplicationTotalAuthenticatedUsersStatQuery.getKey = (variables: ApplicationTotalAuthenticatedUsersStatQueryVariables) => ['ApplicationTotalAuthenticatedUsersStat', variables];

export const useInfiniteApplicationTotalAuthenticatedUsersStatQuery = <
      TData = InfiniteData<ApplicationTotalAuthenticatedUsersStatQuery>,
      TError = unknown
    >(
      variables: ApplicationTotalAuthenticatedUsersStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationTotalAuthenticatedUsersStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationTotalAuthenticatedUsersStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationTotalAuthenticatedUsersStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationTotalAuthenticatedUsersStat.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationTotalAuthenticatedUsersStatQuery, ApplicationTotalAuthenticatedUsersStatQueryVariables>(ApplicationTotalAuthenticatedUsersStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationTotalAuthenticatedUsersStatQuery.getKey = (variables: ApplicationTotalAuthenticatedUsersStatQueryVariables) => ['ApplicationTotalAuthenticatedUsersStat.infinite', variables];


useApplicationTotalAuthenticatedUsersStatQuery.fetcher = (variables: ApplicationTotalAuthenticatedUsersStatQueryVariables) => fetcher<ApplicationTotalAuthenticatedUsersStatQuery, ApplicationTotalAuthenticatedUsersStatQueryVariables>(ApplicationTotalAuthenticatedUsersStatDocument, variables);
